import { render, staticRenderFns } from "./post_list.vue?vue&type=template&id=5a1d290b&scoped=true"
import script from "./post_list.vue?vue&type=script&lang=js"
export * from "./post_list.vue?vue&type=script&lang=js"
import style0 from "./post_list.vue?vue&type=style&index=0&id=5a1d290b&prod&lang=css"
import style1 from "./post_list.vue?vue&type=style&index=1&id=5a1d290b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1d290b",
  null
  
)

export default component.exports